import React, { useRef, useEffect } from 'react'
import { gsap } from 'gsap/dist/gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import Card from 'components/card'

const Stack = ({ category, lang }) => {
  gsap.registerPlugin(ScrollTrigger)

  const ref = useRef(null)

  const nCards = Array.from(
    { length: 4 },
    () => Math.floor(Math.random() * 5) * (Math.round(Math.random()) ? 1 : -1)
  )

  const cardList = nCards.map((item, index) => {
    return (
      <Card
        key={index}
        rotation={item}
        category={category}
        id={index + 1}
        lang={lang}
      />
    )
  })

  return (
    <div ref={ref} className='cardContainer'>
      {cardList}
    </div>
  )
}

// useEffect(() => {
//   const element = card2.current
//   const oldElement = card1.current

//   ScrollTrigger.create({
//     trigger: element,
//     start: 'center center',
//     endTrigger: oldElement,
//     end: 'bottom top',
//     pin: true,
//     pinSpacing: false,
//     pinType: 'fixed',
//     // invalidateOnRefresh: true,
//     anticipatePin: 1
//   })
// }, [])

// useEffect(() => {
//   const element = card3.current
//   const oldElement = card2.current

//   ScrollTrigger.create({
//     trigger: element,
//     start: 'center center',
//     endTrigger: oldElement,
//     end: '100%',
//     pin: true,
//     pinSpacing: false,
//     pinType: 'fixed',
//     // invalidateOnRefresh: true,
//     anticipatePin: 1
//   })
// }, [])

// useEffect(() => {
//   const element = card4.current
//   const oldElement = card3.current

//   ScrollTrigger.create({
//     trigger: element,
//     start: 'center center',
//     endTrigger: oldElement,
//     end: 'bottom bottom',
//     pin: true,
//     pinSpacing: false,
//     pinType: 'fixed',
//     invalidateOnRefresh: true,
//     anticipatePin: 1
//   })
// }, [])

//  return (
//    <div className='cardContainer'>
//    <section
//    ref={card1}
//     style={{
//       transform: `rotate(-10deg)`,
//       zIndex: 4
//     }}
//     className={'pin' + category + '1'}
//   >
//     <img

//       className='playingCard'
//       src={require('images/cards/' + lang + '/' + category + '1.png')}
//     />
//   </section>
//   <section
//     ref={card2}
//     style={{
//       transform: `rotate(3deg)`,
//       zIndex: 3
//     }}
//     className={'pin' + category + '2'}
//   >
//     <img

//       className='playingCard'
//       src={require('images/cards/' + lang + '/' + category + '2.png')}
//     />
//   </section>
//   <section
//   ref={card3}
//     style={{
//       transform: `rotate(-2deg)`,
//       zIndex: 2
//     }}
//     className={'pin' + category + '3'}
//   >
//     <img

//       className='playingCard'
//       src={require('images/cards/' + lang + '/' + category + '3.png')}
//     />
//   </section>
//   <section
//   ref={card4}
//     style={{
//       transform: `rotate(0deg)`,
//       zIndex: 1
//     }}
//     className={'pin' + category + '4'}
//   >
//     <img

//       className='playingCard'
//       src={require('images/cards/' + lang + '/' + category + '4.png')}
//     />
//   </section>
//   </div>
//  )
export default Stack
